import React, { PropTypes, Component } from "react";

import { NitroButton, NitroDivider } from "nitro-components";

import styled from "styled-components";

const Container = styled.section`
  margin-top:5px;
  padding:10px 0px;
  display:flex;
  justify-content:center;
  margin-bottom:20px;
  
  & button{
    background-color:${props => props.theme.color.white};
  }

  & .button-content{
    border: 1px solid ${props => props.theme.color.border};
  }

  & .button-label{
    color:${props => props.theme.color.secondary};
  }

  & .button-content:hover{
    background-color:${props => props.theme.color.white} !important;
    border: 1px solid ${props => props.theme.color.border};
  }

  & svg {
    fill: ${props => props.theme.color.secondary} !important;
    margin-left:60px;
    margin-bottom:2px;
  }
`;

class PanelActionButton extends Component {
  render() {
    // console.log('SummaryTable', this.props);

    const { label, icon, onClick } = this.props;
    return (
      <Container>
        <NitroButton
          block
          label={label}
          leftIcon="edit"
          insideIconSize={16}
          size="medium"
          type=""
          variant="white"
          width=""
          outlined
          action={() => onClick()}
        />
      </Container>
    );
  }
}

PanelActionButton.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  onClick: PropTypes.func
};

export default PanelActionButton;



// WEBPACK FOOTER //
// ./src/components/factoryComponents/PanelActionButton.js